<template>
    <div id="FQDNOverview">
        <fqdn-table :fqdns="fqdns" :statistics="fqdn_statistics"></fqdn-table>
    </div>
</template>

<script>
import FQDNService from '@/api-services/dns_fqdn.service'
import FQDNTable from '@/components/FQDNTable.vue'
import apiutil from '@/util/apiutil'

export default {
  name: 'FQDNOverview',
  data () {
    return {
      fqdns: null,
      fqdn_statistics: null
    }
  },
  created () {
    FQDNService.getOwnFQDNs(this.$store.state).then((response) => {
      this.fqdn_statistics = apiutil.dict_by_value_of_array(response.data.group_fqdns_stat, 'fqdn_gfk')
      this.fqdn_statistics = Object.assign({}, apiutil.dict_by_value_of_array(response.data.ou_fqdns_stat, 'fqdn_gfk'), this.fqdn_statistics)
      this.fqdns = apiutil.uniq_by(response.data.ou_fqdns.concat(response.data.group_fqdns))
      console.debug(response.data.group_fqdns_stat)
      Object.freeze(this.fqdns)
    })
  },
  components: {
    'fqdn-table': FQDNTable
  }
}
</script>
